import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.style.overflow = "hidden";

    // Defer initial grow to ensure content is rendered
    requestAnimationFrame(() => {
      this.grow();
    });

    this.element.addEventListener("input", () => this.grow());
  }

  grow() {
    this.element.style.height = "auto";
    this.element.style.height = `${this.element.scrollHeight}px`;
  }
}
